import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shadcn/ui/dropdown-menu";

import { EllipsisIcon } from "lucide-react";
import Link from "next/link";
import useIsSuperAdmin from "@/hooks/useIsSuperAdmin";

export default function SpecialAdminContextMenu({
  comedianId,
  specialId,
}: {
  comedianId: string;
  specialId: string;
}) {
  const isSuperAdmin = useIsSuperAdmin();
  if (!isSuperAdmin) {
    return null;
  }
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger className="text-gray-500 border-0 active:border-0 hover:bg-gray-200 hover:text-gray-800 rounded-full w-8 h-8 flex items-center justify-center outline-none">
          <EllipsisIcon />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuLabel className="text-xs text-gray-500 font-normal">
            This is only visible to super admins
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <Link
              href={`/internal/comedians/${comedianId}/specials/${specialId}`}
            >
              View Special in Internal
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link href={`/internal/comedians/${comedianId}/edit`}>
              View Comedian in Internal
            </Link>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
